export default "__VITE_ASSET__Ba5OAxor__"